// extracted by mini-css-extract-plugin
module.exports = {"root":"LoadingAlert_root__ZCX7w","content":"LoadingAlert_content__zDzMA"};